
import styled from "styled-components";
import { BsSearch } from 'react-icons/bs'
export const Container = styled.div`
    display: flex;
    flex-shrink:1;
`

export const GContainer = styled.div`
    padding-top:63px;
    padding-bottom:63px;
     @media (max-width:990px){
        display:none;
    }
`
export const Container1 = styled.div`
    display: flex;
    flex-shrink:1;

`

export const Heading = styled.div`
font-size: 30px;
font-weight: 600;
color: #58595B;
cursor: pointer;
margin: 0px 0px 0px 0px;
font-family: Montserrat SemiBold, "Open Sans", Helvetica, Arial, sans-serif !important;
@media (max-width: 1145px) {
    font-size: 24px !important;
    margin:10px 0px 10px 0px;
  } 
@media (max-width: 794px) {
    font-size: 21px !important;

  } 
@media (max-width: 884px) {
    font-size: 16px !important;
    margin:10px 0px 10px 0px;
  } 
@media (min-width: 885px) and (max-width:1024px) {
    font-size: 19px !important;
    margin:7px 0px 10px 0px;
  } 
`
export const Seachbar = styled.div`
position: relative;
flex-shrink: 1;
flex-grow: 1;
background-color: white;
cursor:pointer;
border: 1px solid #c5c5c5;
border-radius: 10px;
width: 100%;
padding: 13px 30px;
font-family: Montserrat SemiBold, "Open Sans", Helvetica, Arial, sans-serif !important;
&:focus{
    border-color: black;
}
@media (max-width: 1525px) {
  width: 100% !important;
  margin:0px;
} 
@media (max-width: 1325px) {
  width: 100% !important;
  margin:0px 0px 0px 0px;
  padding-left: 12px;
  padding-right: 12px;
} 

`

export const Input = styled.input`
    width: 100%;
    border: none !important;
    padding: 5px 0px 0 40px;
    font-size: 16px;
    outline: none !important;
    @media (max-width: 1145px) {
        width: calc(100% - 25px) !important;
      } 
`
export const CustomBsSearch = styled(BsSearch)`
    position: absolute;
    top: 16px;
    left: 22px;
    font-size: 24px;
@media (max-width: 1145px) {
    width: 20px !important;
  } 
`